import { Instance } from 'mobx-state-tree'
import { DailyTaskModelBase } from './DailyTaskModel.base'

/* The TypeScript type of an instance of DailyTaskModel */
export interface DailyTaskModelType extends Instance<typeof DailyTaskModel.Type> {}

/* A graphql query fragment builders for DailyTaskModel */
export { selectFromDailyTask, dailyTaskModelPrimitives, DailyTaskModelSelector } from './DailyTaskModel.base'

/**
 * DailyTaskModel
 */
export const DailyTaskModel = DailyTaskModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
